<div class="app-layout">
  <aside class="sidebar">
    <nav class="sidebar-nav">
      @for (item of navItems; track item.route) {
        <a class="sidebar-link" [routerLink]="item.route" routerLinkActive="active">
          <mat-icon>{{ item.icon }}</mat-icon>
          <span>{{ item.label }}</span>
        </a>
      }
    </nav>
  </aside>

  <main class="sidebar-content">
    <router-outlet></router-outlet>
  </main>
</div>
